import React, { Component } from 'react'
// import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
// import * as actions from '../../actions'
// import * as actionCreators from '../../actions';
import { renderTextField, renderCheckbox, renderSelectField } from '../auth/form_helpers'

import '../../style/style.css';

import RaisedButton from 'material-ui/RaisedButton'
// import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
// import Popover from 'material-ui/Popover';
// import Checkbox from 'material-ui/Checkbox';
// import Divider from 'material-ui/Divider';
// import TextField from 'material-ui/TextField'
// import DatePicker from 'material-ui/DatePicker';
import Paper from 'material-ui/Paper';
// import TextField from 'material-ui/TextField';

// import * as actionCreator from '../../actions'

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  thin: {
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: 0,
    background: '#E1F5FE',
  },
  halfthin: {
    paddingBottom: 0,
    marginBottom: 0,
    background: '#E1F5FE',
  },
  tobottom: {
    bottom: 0,
    top: "auto"
  }
};

var years = [];
var d = new Date();
var n = d.getFullYear();
for (var i = ( n + 2 ); i >= 1989; i--) { 
   years.push({name: i, year: i});
}

class FeesListFilter extends Component {

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Oops: </strong>{this.props.errorMessage}
      </div>
    }
  }

  renderYears() {
    //if (typeof this.props.groupsbyyear !== 'undefined') {
      return <Field
          component={renderSelectField}
          floatingLabelText={"Befizetés dátuma (év)"}
          name={"year"}
        >
          <MenuItem key={101} value='all' primaryText='összes' />
          {
            years.sort(function(a, b){return b.year-a.year}).map((option, index) => {
              return <MenuItem key={index} value={option.year} primaryText={option.year} />
            })
          }
        </Field>
    //}
  }

  /*
  renderCategories() {
    if(typeof this.props.personcategories !== 'undefined') {
      this.props.personcategories[0].map((option, index) => {
        switch (option) {
          case 'all': 
            return <MenuItem key={index} value={option} primaryText="összes" />
          case 'is-member': 
            return <MenuItem key={index} value={option} primaryText="tag" />
          case 'was-in-training': 
            return <MenuItem key={index} value={option} primaryText="kurzuson részt vett" />
          case 'self-knowledge-only': 
            return <MenuItem key={index} value={option} primaryText="csak önismereti" />
          default: 
            return <MenuItem key={index} value={option} primaryText={option} />
        }
      })
    }
  }
  */
  render() {
    if(typeof this.props.feetypes !== 'undefined') {
      const {handleSubmit} = this.props
      return (
        <div>
          {this.renderAlert()}
          <Paper zDepth={1} style={{/*position: "fixed", bottom:"0",*/ width:"100%", background: "#E1F5FE", zIndex: "10"}}>
            <form onSubmit={handleSubmit} className='flexContainer'>
              <Paper zDepth={0} style={styles.thin}>
                <Field
                  component={renderTextField}
                  floatingLabelText="név, email, index, TB, pozicíószám"
                  name="query"
                  type="text"/>
              </Paper>
              <Paper zDepth={0} style={styles.thin}>
                <Field
                  component={renderSelectField}
                  floatingLabelText="típus"
                  name="type"
                  defaultValue="all"
                  menuStyle={{top: 'auto', bottom: 0}}
                >
                  {
                    this.props.feetypes.map((option, index) => {
                      switch (option) {
                        case 'all': 
                          return <MenuItem key={index} value={option} primaryText="összes" />
                        case 'membership-fee': 
                          return <MenuItem key={index} value={option} primaryText="tagdíj" />
                        case 'registration-fee': 
                          return <MenuItem key={index} value={option} primaryText="regisztrációs díj" />
                        case 'group-registration-fee': 
                          return <MenuItem key={index} value={option} primaryText="csoport regisztrációs díj" />
                        default: 
                          return <MenuItem key={index} value={option} primaryText={option} />
                      }
                    })
                  }
                  <MenuItem key={111} value='all' primaryText="összes" />
                </Field>
              </Paper>
              <Paper zDepth={0} style={styles.thin}>
                {this.renderYears()}
                {/*
                <Field
                  component={renderTextField}
                  floatingLabelText="befizetés dátuma (év)"
                  name="year"
                  type="text"/>
                */}
              </Paper>
              <Paper zDepth={0} style={styles.halfthin}>
                <Field
                  component={renderCheckbox}
                  label="el nem engedett tartozás"
                  name="hasDebit"
                  style={styles.checkbox}
                />
              </Paper>
              <Paper zDepth={0} style={styles.halfthin}>
                <RaisedButton type="submit" label="szűrés" primary={true} labelColor={'#FFFFFF'}/>
              </Paper>
            </form>
          </Paper>
        </div>
      )
    } else {
      return (
        <div></div>
      )
    }
  }

}

// PersonListFilter = reduxForm({
//   form: 'personListFilter'
// })(PersonListFilter)

// You have to connect() to any reducers that you wish to connect to yourself
//PersonListFilter = connect(
  //state => ({
  //  initialValues: state.person.thisperson // pull initial values from reducer
  //})//,
  //{ load: loadAccount }               // bind account loading action creator
//)(PersonListFilter)

export default reduxForm({
  form: 'feesListFilter',
  initialValues: {type: 'all'}
})(FeesListFilter)


// WEBPACK FOOTER //
// ./src/components/fees/feesListFilter.js